import type { ModuleItemType, SubmoduleItem } from 'app/types/modules';
import { useTranslate } from 'core/hooks/useTranslate';
import { ROLES_GUID } from 'core/utils/user';
import React, { useEffect, useState } from 'react';
import Button from '../../../../atoms/Button/Button';
import TooltipCustom from '../../../../atoms/Tooltip/Tooltip';

type ItemActionsProps = {
  item: ModuleItemType | SubmoduleItem;
  onDelete?: (item: ModuleItemType | SubmoduleItem) => void;
  onEdit?: (item: ModuleItemType | SubmoduleItem) => void;
  onToggleVisibility?: (item: ModuleItemType | SubmoduleItem) => void;
};

function ItemActions({ item, onDelete, onEdit, onToggleVisibility }: ItemActionsProps): JSX.Element {
  const { t } = useTranslate();
  const [isHidden, setIsHidden] = useState(false);
  const [canEditItem, setCanEditItem] = useState(false);

  useEffect(() => {
    setIsHidden(item.visibility === 0);
    setCanEditItem(item.created_by?.role_guid === ROLES_GUID.TEACHER);
  }, [item]);

  return (
    <div className="item-actions">
      <TooltipCustom title={isHidden ? t('organize-content:Show tooltip') : t('organize-content:Hide tooltip')} placement="top" hasArrow>
        <Button
          variant="plain"
          isIconOnly
          leftIcon={isHidden ? 'visible-off' : 'visible'}
          iconSize="lg"
          ariaLabel={isHidden ? t('organize-content:Show module') : t('organize-content:Hide module')}
          ariaControls={`module-row-visibility-${item.guid}`}
          onClick={() => onToggleVisibility?.(item)}
        />
      </TooltipCustom>
      {canEditItem && (
        <>
          <TooltipCustom title={t('organize-content:Edit tooltip')} placement="top" hasArrow>
            <Button
              variant="plain"
              isIconOnly
              leftIcon="editpost"
              iconSize="lg"
              ariaLabel={t('organize-content:Edit module')}
              ariaControls={`module-row-edit-${item.guid}`}
              onClick={() => onEdit?.(item)}
            />
          </TooltipCustom>
          <TooltipCustom title={t('organize-content:Delete tooltip')} placement="top" hasArrow>
            <Button
              className="item-actions__delete"
              variant="plain"
              isIconOnly
              leftIcon="trash"
              iconSize="lg"
              ariaLabel={t('organize-content:Delete module')}
              ariaControls={`module-row-delete-${item.guid}`}
              onClick={() => onDelete?.(item)}
            />
          </TooltipCustom>
        </>
      )}
    </div>
  );
}

export default ItemActions;
